import React, { FC } from 'react'

import { SliceFormattedText } from 'pages/_serverRendered/CmsPage/types'

import StyledRichText from 'components/MarketingAndPropertyPages/StyledRichText'

const FormattedText: FC<SliceFormattedText> = ({ primary }) => <StyledRichText richText={primary.text} />

export default FormattedText
